import { useContext, useState, useEffect } from "react";
import { Box, Grid, MenuItem, Select, Typography } from "@mui/material";
import LoadingModal from "../common/LoadingModal";
import LoadingWheel from "../common/LoadingWheel";
import ReBox from "../common/ReBox";
import { GlobalContext } from "../common/Context";
import { useTranslation } from "react-i18next";
import { green, purple, text } from "../../theme/colours";
import SignForm from "./components/SignForm";
import { DEV_PROJECT_IDS, PROJECTS } from "../../constants";
import { regionSelId } from "./__fixtures__/constants";

const SignIn = () => {
  const { t } = useTranslation("Account");
  const {
    mobileView,
    tabletView,
    desktopView,
    setOptionState,
    signError,
    setSignError,
    signLoad,
    firebaseState,
    linking,
    setLinking,
    verifying,
    setVerifying,
  } = useContext(GlobalContext);
  const [linkMsg, setLinkMsg] = useState(t("linkingList")[0]);
  const [validInvite, setValidInvite] = useState(false);
  const [willLink, setWillLink] = useState(
    JSON.parse(window.localStorage.getItem("linkClaim")),
  );
  const inviteId = location.state?.inviteId;
  const email = location.state?.email;
  const linkingOptions = {};
  const currentProject = PROJECTS.find(
    (project) => project.id === firebaseState.firebase.app().options.projectId,
  );

  const availabeProjects = PROJECTS.filter((project) =>
    DEV_PROJECT_IDS.includes(currentProject.id)
      ? true
      : !DEV_PROJECT_IDS.includes(project.id),
  );
  if (email) {
    linkingOptions.defaultValue = email;
    linkingOptions.value = email;
  } else {
    window.localStorage.setItem("linkClaim", false);
  }

  const messageBox = {
    position: "absolute",
    top: "55%",
    left: "50%",
    width: "25%",
    height: "30%",
    m: "-12.5%",
    p: "2rem",
    background: "#ffffff",
    textAlign: "center",
  };
  const loadBox = { position: "relative", height: "5rem" };
  const bigText = { mb: "1rem", fontSize: "1.25rem", fontWeight: 900 };
  const bigContainer = {
    height: desktopView ? "100vh" : "auto",
    width: "100%",
    display: "flex",
    flexDirection: (mobileView || tabletView) && "column",
    justifyContent: "space-between",
    p: 0,
  };
  const container = {
    p: 0,
    height: desktopView ? "100%" : "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  const signFormContainer = {
    ...container,
    height: "auto",
  };
  const textFormContainer = {
    ...container,
    alignItems: !desktopView ? "center" : "flex-start",
    width: mobileView ? "90%" : tabletView ? "100%" : "auto",
    order: (mobileView || tabletView) && 1,
    m: mobileView || tabletView ? "0 auto" : "1% 5%",
    textAlign: "center",
  };
  const textContainer = {
    textAlign: "center",
    width: mobileView || tabletView ? "60%" : "75%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    m: "0 auto 3%",
  };
  const halfCircle = {
    width: "30%",
    height: "135vh",
    transform: "translateY(-16%)",
    background: `linear-gradient(0deg, ${purple[3]}, ${green[3]} 75%)`,
    display: "flex",
    postion: "fixed",
  };
  const halfCircleLeft = {
    ...halfCircle,
    borderLeft: "transparent",
    borderTopRightRadius: "100%",
    borderBottomRightRadius: "100%",
    justifyContent: "flex-end",
  };
  const halfCircleRight = {
    ...halfCircle,
    borderRight: "transparent",
    borderTopLeftRadius: "100%",
    borderBottomLeftRadius: "100%",
    justifyContent: "flex-start",
  };
  const circleImage = {
    alignSelf: "center",
    height: "50vh",
  };
  const circleImageLeft = {
    ...circleImage,
    transform: "translateX(6%)",
  };
  const circleImageRight = {
    ...circleImage,
    transform: "translateX(-6%)",
  };
  const mobileCircle = {
    background: `linear-gradient(0deg, ${purple[3]}, ${green[3]} 75%)`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "transparent",
    borderBottomRightRadius: "100%",
    borderBottomLeftRadius: "100%",
    height: tabletView ? "55vh" : "50vh",
    width: "115%",
    mb: "5%",
  };
  const infoText = {
    fontSize: desktopView ? "0.875rem" : "1rem",
    lineHeight: "1.25rem",
    opacity: "40%",
    width: mobileView ? "auto" : "100%",
    mb: "2%",
  };

  const formContainer = {
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    width: tabletView ? "70%" : "80%",
    alignSelf: "center",
    mb: "2%",
  };

  const regionSelect = {
    width: tabletView ? "55%" : "75%",
    m: "1rem 0 1.5rem",
    "& .MuiSelect-select": {
      p: "0.75rem 3rem 0.75rem 2rem !important",
    },
  };
  const flagDisplayBox = {
    display: "flex",
    position: "absolute",
    left: "1rem",
  };
  // Get rid of email and inviteid from location state once page is loaded so they don't persist
  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);

  useEffect(() => {
    setOptionState({
      nav: "dashboard",
      page: null,
    });
  }, [setOptionState]);

  useEffect(() => {
    var i = 0;
    const changeMsg = () => {
      setTimeout(() => {
        const msgs = t("linkingList");
        setLinkMsg(msgs[i + 1]);
        if (i < msgs.length - 2) {
          i++;
          changeMsg();
        }
      }, 5000);
    };
    linking && changeMsg();
  }, [linking, t]);

  useEffect(() => {
    const verify = async () => {
      let valid;
      setValidInvite(valid);
      setWillLink(false);
      if (!valid) {
        setSignError(t("invalidInvite"));
        setLinking(false);
        window.localStorage.setItem("linkClaim", false);
      } else {
        setSignError("");
      }
    };
    if (!verifying && inviteId) {
      setVerifying(true);
      verify();
    }
  }, [
    firebaseState,
    verifying,
    setVerifying,
    setLinking,
    setSignError,
    inviteId,
    email,
    signError,
    t,
  ]);

  return linking ? (
    <ReBox style={{ ...messageBox, ...container }}>
      <Box style={loadBox}>
        <LoadingWheel width={4} />
      </Box>
      <Typography sx={bigText} color="primary">
        {t("hangTight")}
      </Typography>
      <Typography color="primary">{linkMsg}...</Typography>
    </ReBox>
  ) : (
    <Box
      sx={{
        minHeight: "calc(100vh - 4rem)",
      }}>
      <Box sx={bigContainer}>
        {desktopView && (
          <Box sx={halfCircleLeft}>
            <Box
              component="img"
              alt="People with rocket"
              src="/images/login/Updated-SRC-PortalGraphics-Login-Left.webp"
              sx={circleImageLeft}
            />
          </Box>
        )}
        <Box sx={textFormContainer}>
          {signLoad && <LoadingModal width={6} />}
          {!desktopView ? (
            <Box sx={mobileCircle}>
              <Box sx={{ display: "flex", justifyContent: "center", mt: "5%" }}>
                <Box
                  component="img"
                  alt="Safe Roads Logo"
                  src="/images/safeRoads/SRC-NewLogo.webp"
                  sx={{ width: tabletView ? "50%" : "70%" }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  height: "50%",
                }}>
                <Box
                  component="img"
                  alt="People with rocket"
                  src="/images/login/Updated-SRC-PortalGraphics-Login-Left.webp"
                  sx={{ height: "100%", transform: "translateX(5%)" }}
                />
                <Box
                  component="img"
                  alt="People with icons"
                  src="/images/login/Updated-SRC-PortalGraphics-Login-Right.webp"
                  sx={{ height: "100%", transform: "translateX(-5%)" }}
                />
              </Box>
            </Box>
          ) : (
            <Box sx={{ ...textContainer, height: "30vh" }}>
              <Box
                component="img"
                alt="Safe Roads Logo"
                src="/images/safeRoads/SRC-NewLogo.webp"
                sx={{ height: "100%", mb: "15%" }}
              />
            </Box>
          )}
          <Box sx={{ width: "100%" }} id={regionSelId}>
            <Select
              value={currentProject}
              renderValue={(value) => value.name}
              sx={regionSelect}
              startAdornment={
                <Box sx={flagDisplayBox}>
                  {currentProject.icons.map((icon) => (
                    <Box key={icon} sx={{ fontSize: "1rem", mr: "0.25rem" }}>
                      {icon}
                    </Box>
                  ))}
                </Box>
              }>
              {availabeProjects.map((project) => (
                <MenuItem key={project} component="a" href={project.url}>
                  <Grid container height="1.5rem">
                    <Grid
                      item
                      xs={3}
                      sx={{
                        p: "0.25rem",
                        mr: "0.5rem",
                      }}>
                      <Box
                        sx={{
                          display: "flex",
                          left: "1rem",
                        }}>
                        {project.icons.map((icon) => (
                          <Box
                            key={icon}
                            sx={{ fontSize: "1rem", mr: "0.25rem" }}>
                            {icon}
                          </Box>
                        ))}
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{ display: "flex", alignItems: "center" }}>
                      <Typography>{project.name}</Typography>
                    </Grid>
                  </Grid>
                </MenuItem>
              ))}
            </Select>
            <Typography color={text.primary} sx={infoText}>
              {t("desc")}
            </Typography>
          </Box>
          <Box sx={formContainer}>
            <SignForm
              container={signFormContainer}
              validInvite={validInvite}
              willLink={willLink}
            />
          </Box>
        </Box>
        {desktopView && (
          <Box sx={halfCircleRight}>
            <Box
              component="img"
              alt="People with icons"
              src="/images/login/Updated-SRC-PortalGraphics-Login-Right.webp"
              sx={circleImageRight}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SignIn;
